import { useMemo } from "react";
import useSWR from "swr";

import { SortQueryDirection, usePaginationControls } from "@ds-cps/ui";

import { apiUsersEndpoints } from "@api/Endpoints";

import { fetcher } from "@utils/swrUtils";

import {
  AzureApplicationUserModel,
  AzureApplicationUserModelKeys
} from "../models/api-users-models";
import { CreateParamsForApiUsers } from "./CreateParamsForApiUsers";

export function useGetApiUsers(
  activeSort?: string,
  sortDirection?: SortQueryDirection
) {
  const { pageIndex, pageSize } = usePaginationControls();

  const params = new CreateParamsForApiUsers();
  params.withPagination(pageSize, pageIndex);

  if (activeSort) {
    // then it will be backend Sorting approach
    params.withSortBy(activeSort as AzureApplicationUserModelKeys);
  }

  if (sortDirection) {
    // then it will be backend Sorting approach
    params.withSortDirection(sortDirection);
  }

  const url = apiUsersEndpoints.usersList() + `?${params.toString()}`;

  const { data, error, isLoading } = useSWR<AzureApplicationUserModel[], Error>(
    url,
    fetcher,
    { revalidateOnFocus: false }
  );

  return useMemo(
    () => ({ apiUsers: data, isLoading, error }),
    [data, isLoading, error]
  );
}
